<template>
    <section class="section section--quote" v-bind:class="{ 'has-link': link }">
        <parallax sectionClass="section__background" :speed-factor="0.3">
            <img :src="require('../assets/' + image)" alt="">
        </parallax>
        <div class="section__quote">
            <h2>{{ quote }}</h2>
            <a :href="link.link" target="_blank" class="btn" v-if="link">{{ link.text }}</a>
        </div>
    </section>
</template>

<script>
    import Parallax from 'vue-parallaxy';

    export default {
        name: 'Quote',
        components: {
            Parallax
        },
        props: {
            image: String,
            quote: String,
            link: Object
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {
        position: relative;

        &__background {
            position: relative;
            height: 40rem !important;
            scroll-behavior: smooth;
            overflow: hidden;
            z-index: -1;

            &::after {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, .7);
                content: "";
            }
        }

        &__quote {
            position: absolute;
            top: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            align-content: center;
            width: 100%;
            height: 100%;
            padding: 0 15%;
            z-index: 1;

            h2 {
                width: 100%;
                margin: 0;
                line-height: 1.5;
                text-align: center;
                font-style: italic;
                font-weight: 300;
                font-size: 4rem;
                color: #fff;
            }

            .btn {
                margin-top: 5rem;
            }
        }

        &--quote {
            padding: 0;
        }
    }

    @media (max-width: 767px) {

        .section {

            &__quote {

                h2 {
                    font-size: 3rem;
                }
            }
        }
    }

    @media (max-width: 499px) {

        .section {

            &__quote {
                padding: 0 2rem;

                h2 {
                    font-size: 2.5rem;
                }
            }
        }
    }

</style>
